import React, { useState, useEffect } from 'react'
import StatsComponent from '../../BuisnessDashboard/common/StatsComponent'
import CustomDateFilter from '../../BuisnessDashboard/common/CustomDateFilter'
import FunnelChart3 from '../../BuisnessDashboard/common/FunnelChart3'
import PieCharts from '../../BuisnessDashboard/common/PieChart';
import moment from 'moment'
import Loader from '../../../../presentationals/Loader/Loader.component'
import { getMArketingPerformanceStatsByDate, getAggregatorDetailsByDateFilter, getAggregatorLeadsPayoutByDate } from '../ActionCreator'
import { InitalDateFn } from '../../../../../utils/commonUtility'
import { getAggregatorEventsByMonth } from '../../maketingComponents/actioncreator'
import { ChevronLeft } from 'lucide-react';
import CopyAllIcon from '@mui/icons-material/CopyAll';
import { CASHBRIDGE_LIKE, CHECK_COMPANY_TENANT, CREDFIN_LIKE, CREDITJAR_LIKE } from '../../../../../layouts/MainTenantconfig';
import DateFilterSelect from "../../../../CustomDatePicker/DateFilterSelectold";

// const PieData = [
//     { name: 'Within Budget', value: 60, colorTheme: "#035865" },
//     { name: 'Near Limit', value: 25, colorTheme: "#42A4C7" },
//     { name: 'Over Budget', value: 15, colorTheme: "#74529D" },
// ];

const customMarginTop = window.innerWidth > 1800 ? "60px" : "30px"
export default function Dashboard({ handleTab, handleBack, handleFilter, commonFilter }) {
  const msiteURL = CHECK_COMPANY_TENANT(CASHBRIDGE_LIKE) ? "https://loan.cashbridge.in?id=" : CHECK_COMPANY_TENANT(CREDFIN_LIKE) ? "https://msite.credfin.money?id=" : CHECK_COMPANY_TENANT(CREDITJAR_LIKE) ? "https://loan.creditjar.in?id=" : "";
  const AppURL = CHECK_COMPANY_TENANT(CASHBRIDGE_LIKE) ? "https://play.google.com/store/apps/details?id=com.cashbridge.app&referrer=agentid%3D" : CHECK_COMPANY_TENANT(CREDFIN_LIKE) ? "https://play.google.com/store/apps/details?id=com.credfin.money&referrer=agentid%3D" : CHECK_COMPANY_TENANT(CREDITJAR_LIKE) ? "https://play.google.com/store/apps/details?id=com.creditjar.app&referrer=agentid%3D" : "";
  const [tableData, setTableData] = useState([])
  const [loader, setLoader] = useState(false)

  const [topAggregatorData, setTopAggregatorData] = useState([])
  const [payload, setPayload] = useState({ Aggregator: "", Partner: "", Campaign: "", Platform: "" })
  // const [dateFilterPopup, setDateFilterPopup] = useState({ show: false, from: moment().subtract(6, 'days').format("YYYY-MM-DD"), to: moment(new Date).format("YYYY-MM-DD") })
  const [dateFilterPopup, setDateFilterPopup] = useState({ show: false, from: commonFilter?.fromDate, to: commonFilter?.toDate  })
  const [statsOption, setStatsOption] = useState({})
  const [funnelDataState, setFunnelDatastate] = useState({})
  const [PieData, setPieData] = useState([])
  const [topAggregator, setTopAggregator] = useState([])
  const [piecenterData, setPiecenterData] = useState("")
  const [isFilterCleared, setIsFilterCleared] = useState(false);

  useEffect(() => {
    if (
      commonFilter?.fromDate !== dateFilterPopup.from ||
      commonFilter?.toDate !== dateFilterPopup.to
    ) {
      setDateFilterPopup((prev) => ({
        ...prev,
        from: commonFilter.fromDate,
        to: commonFilter.toDate
      }));
    }

    statsFn(commonFilter.fromDate, commonFilter?.toDate)
    FunnelData(commonFilter.fromDate, commonFilter?.toDate)
    PiechartFn(commonFilter.fromDate, commonFilter?.toDate)
    topList(commonFilter.fromDate, commonFilter?.toDate)
  }, [commonFilter]);

  const handleDateFilterPopup = (type, val) => {
    setDateFilterPopup((prev) => ({ ...prev, [type]: val }))
    const formatted = moment(val).format("YYYY-MM-DD");

    setDateFilterPopup((prev) => {
      if (prev[type] === formatted) return prev; // prevent useless update

      return {
        ...prev,
        [type]: formatted
      };
    });

    if (type === "from") {
      if (commonFilter.fromDate !== formatted) {
        handleFilter("fromDate", formatted);
      }
    } else {
      if (commonFilter.toDate !== formatted) {
        handleFilter("toDate", formatted);
      }
    }
  }

  const handleApplyDteFilter = () => {
    handleDateFilterPopup("show", false)
    statsFn(dateFilterPopup?.from, dateFilterPopup?.to)
    FunnelData(dateFilterPopup?.from, dateFilterPopup?.to)
    PiechartFn(dateFilterPopup?.from, dateFilterPopup?.to)
    topList(dateFilterPopup?.from, dateFilterPopup?.to)
  }

  const handlechangeSelectBox = (e, type) => {
    setPayload((prev) => ({
      ...prev,
      [type]: e.target.value
    }))
  }

  const handleReset = () => {
    
    const today = moment(new Date).format("YYYY-MM-DD");
    setIsFilterCleared(true);
    setDateFilterPopup({
      show: false,
      from: today,
      to: today,
    });

    setTimeout(() => {
      statsFn({ from: today, to: today });
      FunnelData({ from: today, to: today });
      PiechartFn({ from: today, to: today });
      topList({ from: today, to: today });
      setIsFilterCleared(false);
    }, 200);
  }

  const handleInfo = (type, data) => {
    handleTab(type, data)
  }

  useEffect(() => {
    statsFn(dateFilterPopup?.from, dateFilterPopup?.to)
    FunnelData(dateFilterPopup?.from, dateFilterPopup?.to)
    PiechartFn(dateFilterPopup?.from, dateFilterPopup?.to)
    topList(dateFilterPopup?.from, dateFilterPopup?.to)
  }, [])

  const statsFn = (sdate, edate) => {
    const start = moment(sdate).format("DD-MM-YYYY")
    const end = moment(edate).format("DD-MM-YYYY")
    setLoader(true)
    getMArketingPerformanceStatsByDate(start, end, callback => {
      setLoader(false)
      setStatsOption({
        "Total Aggregator": callback?.data?.[0]?.totalAggregators ?? 0,
        "Active Aggregator": callback?.data?.[0]?.activeAggregators ?? 0,
        "Approval → Disbursement %": callback?.data?.[0]?.approvalDisbursementRate ?? 0,
        "Average Ticket Size (ATS)": callback?.data?.[0]?.ats ?? 0,
        "Total Disbursement Amount (MTD / QTD)": callback?.data?.[0]?.totalDisbursementAmount ?? 0,
        "Budgeted Disbursement Amount": callback?.data?.[0]?.budgetedDisbursementAmt ?? 0,
        "Variance (₹ & %)": callback?.data?.[0]?.variance ?? 0,
        "Total Leads Received": callback?.data?.[0]?.totalLeads ?? 0,
        "Total Payout Amount": callback?.data?.[0]?.payoutAmount ?? 0,
      })
    })
  }

  const FunnelData = (sdate, edate) => {
    const start = moment(sdate).format("DD-MM-YYYY")
    const end = moment(edate).format("DD-MM-YYYY")
    setLoader(true)
    getAggregatorEventsByMonth(start, end, callback => {
      setLoader(false)
      setFunnelDatastate(callback?.data ?? [])
    })
  }
  const PiechartFn = (sdate, edate) => {
    const start = moment(sdate).format("DD-MM-YYYY")
    const end = moment(edate).format("DD-MM-YYYY")
    setLoader(true)
    getAggregatorDetailsByDateFilter(start, end, "", callback => {
      setLoader(false)
      setTableData(callback?.data ?? [])
      const obj = callback?.data[callback?.data?.length - 1]
      setPiecenterData(obj?.avgDailySpent ?? 0)
      setPieData([
        { name: 'Within Budget', value: obj?.withinBudget ?? 0, colorTheme: "#035865" },
        { name: 'Budget Allocated', value: obj?.budgetAllocated ?? 0, colorTheme: "#42A4C7" },
        { name: 'Budget Remaining', value: obj?.budgetRemaining ?? 0, colorTheme: "#74529D" },
        { name: 'Budget Utilized', value: obj?.overallUtilizedBudget ?? 0, colorTheme: "#3d7a15" },
      ])
    })
  }
  const topList = (sdate, edate) => {
    const start = moment(sdate).format("DD-MM-YYYY")
    const end = moment(edate).format("DD-MM-YYYY")
    setLoader(true)
    getAggregatorLeadsPayoutByDate(start, end, callback => {
      setLoader(false)
      setTopAggregator(callback?.data ?? [])

    })
  }

  const handleCustomDetails = (id) => {
    // const start = moment(dateFilterPopup?.from).format("DD-MM-YYYY")
    // const end = moment(dateFilterPopup?.to).format("DD-MM-YYYY")
    // setLoader(true)
    // getAggregatorDetailsByDateFilter(start, end, id, callback => {
    //     setLoader(false)
    // })
    const obj = {
      start: moment(dateFilterPopup?.from).format("DD-MM-YYYY"),
      end: moment(dateFilterPopup?.to).format("DD-MM-YYYY"),
      id: id?.aggregatorId,
      name: id?.aggregatorName,
    }
    handleInfo("view", obj)
  }

  const handleCopy = (type,id) => {
    if(type == "msite"){

      const url = `${msiteURL}${id}`
      navigator.clipboard.writeText(url);
      alert("Link copied Successfully!")
    }else{
       const url = `${AppURL}${id}`
      navigator.clipboard.writeText(url);
      alert("Link copied Successfully!")
    }
  }


  return (
    <>
      {loader ? <Loader /> : ""}
      <div className='OverView-Main-Section min-size-marketing-1800'>

        <div className='HeadingFilter-Section'>
          <div>
            <h4 onClick={(e) => handleBack(e)}
              style={{
                margin: 0,
                display: 'flex', gap: '5px', alignItems: 'center', whiteSpace: 'nowrap', cursor: 'pointer'
              }}
            > <ChevronLeft />Aggregator Management</h4>
          </div>
          <div className='topsTabs' style={{ border: 'none' }}>
            <div className='rightTabs' style={{ padding: '0' }}>
              <button className={`rightSideBtn active`} style={{ background: '#035865', color: '#fff' }} onClick={() => handleInfo("add", "")}>Add New Aggregator</button>
            </div>
          </div>
        </div>
        <div style={{ margin: window.innerWidth > 1800 ? '0 4%' : "" }}>
           <div className='HeadingFilter-main-filters' style={{ marginTop: customMarginTop }}>
            <div className="row">
              <div className="col-xl-9 col-lg-10 col-xs-12" style={{ display: 'flex', gap: '10px', marginTop: '5px' }}>
                <DateFilterSelect
                  value={[new Date(commonFilter.fromDate), new Date(commonFilter.toDate)]}
                  onChange={(range) => {
                    handleDateFilterPopup("from", range[0]);
                    handleDateFilterPopup("to", range[1]);
                  }}
                  isFilterCleared={isFilterCleared}
                />
                {/* <div className='custom-popup' style={{ width: '30%' }}>
                                    <div className='customSelectBox ' style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '20px', cursor: 'pointer' }} onClick={() => handleDateFilterPopup("show", !dateFilterPopup?.show)}>
                                        <div style={{ display: 'flex', gap: '7px', alignItems: 'center' }}>
                                            <svg width="9" height="9" viewBox="0 0 9 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M6 0.75V2.25M3 0.75V2.25" stroke="#0C0B10" stroke-width="0.5625" stroke-linecap="round" stroke-linejoin="round" />
                                                <path d="M4.875 1.5H4.125C2.71079 1.5 2.00368 1.5 1.56434 1.93934C1.125 2.37868 1.125 3.08579 1.125 4.5V5.25C1.125 6.6642 1.125 7.37134 1.56434 7.81065C2.00368 8.25 2.71079 8.25 4.125 8.25H4.875C6.2892 8.25 6.99634 8.25 7.43565 7.81065C7.875 7.37134 7.875 6.6642 7.875 5.25V4.5C7.875 3.08579 7.875 2.37868 7.43565 1.93934C6.99634 1.5 6.2892 1.5 4.875 1.5Z" stroke="#0C0B10" stroke-width="0.5625" stroke-linecap="round" stroke-linejoin="round" />
                                                <path d="M1.125 3.75H7.875" stroke="#0C0B10" stroke-width="0.5625" stroke-linecap="round" stroke-linejoin="round" />
                                            </svg>

                                            {
                                                dateFilterPopup?.from && dateFilterPopup?.to
                                                    ? `${moment(dateFilterPopup?.from).format("DD MMM YYYY")} - ${moment(dateFilterPopup?.to).format("DD MMM YYYY")}`
                                                    : "Select Date Range"
                                            }
                                        </div>
                                        <div style={{ marginTop: '-5px' }}>
                                            <svg width="8" height="4" viewBox="0 0 8 4" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M7.375 0.375025C7.375 0.375025 4.79731 3.375 3.875 3.375C2.95263 3.375 0.375 0.375 0.375 0.375" stroke="#686C70" stroke-width="0.75" stroke-linecap="round" stroke-linejoin="round" />
                                            </svg>
                                        </div>
                                    </div>
                                    {
                                        dateFilterPopup?.show ?
                                            <CustomDateFilter
                                                payload={dateFilterPopup}
                                                handlechange={handleDateFilterPopup}
                                                handleApply={handleApplyDteFilter}
                                            />
                                            : ""}
                                </div> */}
                {/* <select className='customSelectBox' value={payload?.Aggregator} onChange={(e) => handlechangeSelectBox(e, "Aggregator")}>
                                <option value="">Select Aggregator</option>
                            </select>
                            <select className='customSelectBox' value={payload?.Partner} onChange={(e) => handlechangeSelectBox(e, "Partner")}>
                                <option value="">Select Partner</option>
                            </select>
                            <select className='customSelectBox' value={payload?.Campaign} onChange={(e) => handlechangeSelectBox(e, "Campaign")}>
                                <option value="">Select Campaign</option>
                            </select>
                            <select className='customSelectBox' value={payload?.Platform} onChange={(e) => handlechangeSelectBox(e, "Platform")}>
                                <option value="">Select Platform</option>
                            </select> */}
              </div>
              <div className="col-xl-3 col-lg-2 col-xs-12" style={{ marginTop: '5px' }}>
                <div style={{ display: 'flex', gap: '8px', justifyContent: window.innerWidth > 1200 ? 'end' : "start" }}>
                  {/* <div className='custom-btn'>
                                    <i class="fa fa-filter" aria-hidden="true"></i>
                                </div> */}
                  <div className='custom-btn'>
                    <i class="fa fa-times" aria-hidden="true" onClick={() => handleReset()}></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div>
            <StatsComponent
              Data={statsOption}
            />
          </div>

         


          <div className="row">
            <div className="col-lg-4 col-md-6 col-xs-12" style={{ marginTop: customMarginTop }}>
              <div>
                <FunnelChart3
                  heading={"Funnel Visualisation"}
                  Data={funnelDataState}
                />
              </div>
            </div>
            <div className="col-lg-4 col-md-6 col-xs-12" style={{ marginTop: customMarginTop }}>
              <div>
                <PieCharts
                  height={"265"}
                  heading={"Funnel Visualisation"}
                  pieData={PieData} centerData={piecenterData}
                />
              </div>
            </div>
            <div className="col-lg-4 col-md-6 col-xs-12" style={{ marginTop: customMarginTop }}>
              <div className="customDash-table" style={{ height: '333px' }}>
                <div>
                  <h5>Top Aggregators by Leads</h5>
                </div>
                <div className='main-customized-table' style={{ OverflowY: 'auto', height: '274px' }}>
                  <table className='table'>
                    <thead>
                      <tr>
                        <th>Info</th>
                        <th>Aggregator </th>
                        <th>Leads</th>
                        <th>Payout</th>

                      </tr>
                    </thead>
                    <tbody>
                      {
                        topAggregator?.length > 0 ? topAggregator?.map((val, id) => {
                          return (
                            <tr key={id}>
                              <td>
                                <div className='InfoIcon'>
                                  <h5 onClick={() => handleCustomDetails(val)}>
                                    i
                                  </h5>
                                </div>
                              </td>
                              <td>
                                {val?.aggregatorName ?? ""}
                              </td>

                              <td>
                                {val?.totalLeads ?? ""}

                              </td>
                              <td>
                                {val?.payoutAmount ?? ""}
                              </td>
                            </tr>
                          )
                        })
                          : ""}



                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>

          <div className="row" style={{ marginTop: customMarginTop }}>
            <div className="col-xs-12">
              <div className="customDash-table" >
                <div>
                  <h5>Aggregator Table</h5>
                </div>
                <div className='main-customized-table'>
                  <table className='table'>
                    <thead>
                      <tr>
                        <th>Info</th>
                        <th>Aggregator Name</th>
                        <th>Aggregator ID</th>
                        <th>Leads</th>
                        <th>Potential Leads</th>
                        {/* <th>Rule</th> */}
                        <th>Partners</th>
                        <th>Active Campaigns</th>
                        {/* <th>Events</th> */}
                        <th>CRM Mapping Key</th>
                        {/* <th>Commercial Model</th> */}
                        <th>Budget Utilization</th>
                        <th>Status</th>
                        {
                          CHECK_COMPANY_TENANT(CASHBRIDGE_LIKE) || CHECK_COMPANY_TENANT(CREDFIN_LIKE) || CHECK_COMPANY_TENANT(CREDITJAR_LIKE) ?
                          <>
                            <th>Msite Link</th>
                            <th>App Link</th>
                            </>
                            : ""}
                      </tr>
                    </thead>
                    <tbody>
                      {
                        tableData?.length > 0 ? tableData?.map((val, id) => {
                          if (id + 1 == tableData?.length) return null;
                          return (
                            <tr key={id}>
                              <td>
                                <div className='InfoIcon' onClick={() => handleCustomDetails(val)}>
                                  <h5>
                                    i
                                  </h5>
                                </div>
                              </td>
                              <td>{val?.aggregatorName ?? ""}</td>
                              <td>{val?.aggregatorId ?? ""}</td>
                              <td>{val?.totalLeads ?? ""}</td>
                              <td>{val?.potentialLeads ?? ""}</td>
                              <td>{val?.partners ?? ""}</td>
                              <td>{val?.activeCampaigns ?? ""}</td>

                              <td>
                                {
                                  val?.costModelType ?
                                    <div style={{
                                      borderRadius: '6px', padding: '5px 10px',
                                      background: "#FFF5C7",
                                      color: "#A47E06",
                                      width: 'fit-content', margin: '0 auto'
                                    }}>

                                      {val?.costModelType ?? ""}
                                    </div>
                                    : "-"}
                              </td>
                              <td>
                                <div className='progressbar'>
                                  <div className="progress">
                                    <div className="progress-width" style={{ background: '#F49F28', width: val?.budgetUtilization + "%" }}></div>
                                  </div>
                                  <h5>{val?.budgetUtilization ?? ""}%</h5>
                                </div>
                              </td>

                              <td> <div style={{ borderRadius: '6px', padding: '5px 10px', background: val?.status ? "#35A04F2B" : "#a035352b", color: val?.status ? "#327E45" : "#a93636", width: 'fit-content', margin: '0 auto' }}>
                                {val?.status ? "Active" : "Inactive"}
                              </div></td>
                              {
                                CHECK_COMPANY_TENANT(CASHBRIDGE_LIKE)|| CHECK_COMPANY_TENANT(CREDFIN_LIKE) || CHECK_COMPANY_TENANT(CREDITJAR_LIKE)?
                                <>
                                  <td>
                                    <a href={`${msiteURL}${val?.aggregatorId}`} target='_blank'>
                                      {msiteURL?.slice(0,30)}...
                                    </a>
                                    &nbsp;&nbsp;
                                    <CopyAllIcon style={{ cursor: 'pointer' }} onClick={() => handleCopy("msite",val?.aggregatorId)} />
                                  </td>
                                  <td>
                                    <a href={`${AppURL}${val?.aggregatorId}`} target='_blank'>
                                      {AppURL?.slice(0,30)}...
                                    </a>
                                    &nbsp;&nbsp;
                                    <CopyAllIcon style={{ cursor: 'pointer' }} onClick={() => handleCopy("app",val?.aggregatorId)} />
                                  </td>
                                  </>
                                  : ""}
                            </tr>
                          )
                        })
                          : ""}



                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>



      </div>
    </>
  )
}
